import React from 'react';
import styles from './WorldCupFixtures.module.css';
import { getFlagUrl } from '../../../server/services/custom-pages/worldcupFlags';

const formatDateStr = (dateStr) => {
  if (!dateStr) return '';
  try {
    const d = new Date(dateStr + 'T00:00:00');
    return d.toLocaleDateString('en-US', { day: '2-digit', month: 'short' });
  } catch (e) {
    return dateStr;
  }
};

const formatGoalDiff = (gd, isFinished) => {
  const n = Number(gd);
  if (isNaN(n)) return '-';
  if (n === 0) {
    return isFinished ? '0' : '-';
  }
  return n > 0 ? `+${n}` : String(n);
};

const formatStat = (val, isFinished) => {
  const n = Number(val);
  if (isNaN(n)) return '-';
  if (n === 0) {
    return isFinished ? '0' : '-';
  }
  return String(n);
};

export default function WorldCupFixtures({ matches }) {
  if (!matches || matches.length === 0) {
    return (
      <div className={styles.sectionContainer}>
        <h2 className={styles.sectionHeading}>Fixtures</h2>
        <div className={styles.fullDivider} />
        <div style={{ padding: '40px 0', color: 'rgba(255,255,255,0.4)', textAlign: 'center' }}>
          Fixtures are currently unavailable.
        </div>
      </div>
    );
  }

  return (
    <div className={styles.sectionContainer}>
      <h2 className={styles.sectionHeading}>Fixtures</h2>
      <div className={styles.fullDivider} />
      <div className={styles.fixturesScrollTrack}>
        {matches.map((match) => {
          const team1Flag = getFlagUrl(match.team1);
          const team2Flag = getFlagUrl(match.team2);
          const dateStr = formatDateStr(match.date);
          const statusTypeLower = (match.statusType || '').trim().toLowerCase();
          const statusLower = (match.status || '').trim().toLowerCase();
          const isFinished = statusTypeLower === 'finished' || statusLower.includes('finished');

          return (
            <div key={match.eventId} className={styles.fixtureCard}>
              <div className={styles.fixtureCardHeader}>
                <span className={styles.fixtureGroupLabel}>{match.groupName}</span>
                <div className={styles.fixtureHeaderRow}>
                  <span className={styles.fixtureDateTime}>
                    <span className={styles.fixtureDateBold}>{dateStr}</span>{' '}{match.time}
                  </span>
                  <div className={styles.fixtureColLabels}>
                    <span className={styles.fixtureColLabel}>W</span>
                    <span className={styles.fixtureColLabel}>GD</span>
                  </div>
                </div>
              </div>
              <div className={styles.fixtureTeamsList}>
                <div className={styles.fixtureTeamRow}>
                  <div className={styles.fixtureTeamLeft}>
                    {team1Flag && (
                      <img src={team1Flag} alt="" className={styles.fixtureTeamFlag} loading="lazy" />
                    )}
                    <span className={styles.fixtureTeamName}>{match.team1}</span>
                  </div>
                  <div className={styles.fixtureTeamStats}>
                    <span className={styles.fixtureStatVal}>{formatStat(match.team1Wins, isFinished)}</span>
                    <span className={styles.fixtureStatVal}>{formatGoalDiff(match.team1GoalDiff, isFinished)}</span>
                  </div>
                </div>
                <div className={styles.fixtureTeamRow}>
                  <div className={styles.fixtureTeamLeft}>
                    {team2Flag && (
                      <img src={team2Flag} alt="" className={styles.fixtureTeamFlag} loading="lazy" />
                    )}
                    <span className={styles.fixtureTeamName}>{match.team2}</span>
                  </div>
                  <div className={styles.fixtureTeamStats}>
                    <span className={styles.fixtureStatVal}>{formatStat(match.team2Wins, isFinished)}</span>
                    <span className={styles.fixtureStatVal}>{formatGoalDiff(match.team2GoalDiff, isFinished)}</span>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

